import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ThankYou from "./pages/ThankYou";
import TestimonialsPage from "./pages/TestimonialsPage";
import BoardPage from "./pages/BoardPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ImpactMapPage from "./pages/ImpactMapPage";
import LegacyPage from "./pages/LegacyPage";
import VolunteerPage from "./pages/VolunteerPage";
import DonorPortal from "./pages/DonorPortal";
import CampaignsPage from "./pages/CampaignsPage";
import CampaignDetailPage from "./pages/CampaignDetailPage";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/temoignages" element={<TestimonialsPage />} />
              <Route path="/testimonials" element={<TestimonialsPage />} />
              <Route path="/conseil-administration" element={<BoardPage />} />
              <Route path="/board" element={<BoardPage />} />
              <Route path="/actualites" element={<BlogPage />} />
              <Route path="/news" element={<BlogPage />} />
              <Route path="/actualites/:slug" element={<BlogPostPage />} />
              <Route path="/news/:slug" element={<BlogPostPage />} />
              <Route path="/carte-impact" element={<ImpactMapPage />} />
              <Route path="/impact-map" element={<ImpactMapPage />} />
              <Route path="/campagnes" element={<CampaignsPage />} />
              <Route path="/campaigns" element={<CampaignsPage />} />
              <Route path="/campagnes/:slug" element={<CampaignDetailPage />} />
              <Route path="/campaigns/:slug" element={<CampaignDetailPage />} />
              <Route path="/legs" element={<LegacyPage />} />
              <Route path="/legacy" element={<LegacyPage />} />
              <Route path="/benevole" element={<VolunteerPage />} />
              <Route path="/volunteer" element={<VolunteerPage />} />
              <Route path="/mon-espace" element={<DonorPortal />} />
              <Route path="/my-space" element={<DonorPortal />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
